import React from 'react';
import styled from 'astroturf/react';
import { NewsPreview } from 'js/social/shared/types';
import { CollapsedActivityPreview } from 'js/social/CollapsedActivityPreview';

const PreviewContainer = styled.div`
  padding: 12px;
  border: 1px solid $ds-gray-light;
`;

interface Props {
  displayName: string;
  isOwner: boolean;
  preview?: NewsPreview;
  onsitePodcastPromotion?: boolean;
}

const CollapsedActivity: React.FC<React.PropsWithChildren<Props>> = ({
  displayName,
  isOwner,
  preview,
  children,
  onsitePodcastPromotion = false,
}) => {
  return (
    <PreviewContainer>
      {children}

      {!preview ? (
        !isOwner && `${displayName} hasn't posted recently`
      ) : (
        <CollapsedActivityPreview
          displayName={displayName}
          preview={preview}
          onsitePodcastPromotion={onsitePodcastPromotion}
        />
      )}
    </PreviewContainer>
  );
};

export default CollapsedActivity;
